import React, { useState } from "react";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import HistoryTable from "../component/HistoryTable";

const History = (props) => {
  return (
    <div>
      <Header />
      <PageTitle />
      <div className="history mb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <HistoryTable />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default History;
